// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"02b238bc","252":"0c93ed4f","345":"5b93ddb3","403":"04521122","596":"d51930ff","599":"54a38014","809":"21ea4b0f","811":"a021a1d2","840":"7f6d9366","866":"5b8b023f","939":"f09f2917","988":"e1e84b57"}[chunkId] + ".chunk.css";
};